export default __webpack_public_path__ + "static/media/add-user.2a86b099.svg";